import * as React from 'react';
import { UnderConstruction } from 'components/UnderConstruction';

export const TenantGroups = () => <div data-testid="tenant-groups-page"><UnderConstruction /></div>;
